// extracted by mini-css-extract-plugin
export default {"text":"AboutMe_text__rMSrY","aboutMe":"AboutMe_aboutMe__INeqB","title":"AboutMe_title__RH4kr"};